<script>
  import alterarEmailServico from './servico';

  export default {
    data() {
      return {
        atual: '',
        nova: '',
        confirmacao: '',
      }
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');

        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              return alterarEmailServico.alterarSenha(this.atual, this.nova);
            } else {
              throw new Error("validacao");
            }
          })
          .then(() => {
            toastr.success(`E-mail alterado com sucesso.`);
            this.$router.push({ name: 'home' });
          })
          .catch(erro => {
            $('#salvar').button('reset');

            if (erro.status === 400) {
              this.$swal(
                '',
                `E-mail atual incorreto.`,
                'error'
              );
            } else {
              this.$mensagemErro(erro, 'Erro ao alterar o e-mail.');
            }
          });
      },
    },
    mounted() {
      this.$root.tituloDaPagina = 'Alterar E-mail';

      this.$root.botaoAcaoMostrar = false;
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-md-4">
              <div class="form-group" :class="{'has-error': errors.has('emailAtual')}">
                <label class="control-label" for="email-atual">E-mail atual</label>

                <input
                  type="text"
                  class="form-control"
                  id="email-atual"
                  v-model="atual"
                  data-vv-name="emailAtual"
                  data-vv-as="E-mail atual"
                  v-validate="'email'">

                <p class="text-danger" v-show="errors.has('emailAtual')">{{ errors.first('emailAtual') }}</p>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group required" :class="{'has-error': errors.has('novoEmail')}">
                <label class="control-label" for="nova-senha">Novo e-mail</label>

                <input
                  type="text"
                  class="form-control"
                  id="nova-senha"
                  name="Novo e-mail"
                  v-model="nova"
                  data-vv-name="novoEmail"
                  data-vv-as="Novo e-mail"
                  v-validate="'required|email'">

                <p class="text-danger" v-show="errors.has('novoEmail')">{{ errors.first('novoEmail') }}</p>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group required" :class="{'has-error': errors.has('confirmacaoEmail')}">
                <label class="control-label" for="confirmacao">Confirmação de e-mail</label>

                <input
                  type="text"
                  class="form-control"
                  id="confirmacao"
                  v-model="confirmacao"
                  data-vv-name="confirmacaoEmail"
                  data-vv-as="Confirmação de e-mail"
                  v-validate="'required|email|confirmed:Novo e-mail'">

                <p class="text-danger" v-show="errors.has('confirmacaoEmail')">{{ errors.first('confirmacaoEmail') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <button
                  id="salvar"
                  type="button"
                  class="btn btn-primary"
                  @click="salvar"
                  data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/alterar-email/AlterarEmail.vue